
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic07 as ObiLogic07Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-07.js';
 
 
 

 
 export const ObiLogic07 = createComponent({
   react: React,
   tagName: 'obi-logic-07',
   elementClass: ObiLogic07Element,
   events: {
     
   }
  });
 
 